__webpack_require__.p = "/app-receitas/";